<template>
  <div class="publish-loadig-container">
    <div class="spin-box">
      <Spin :pointNum="8" :translateX="25" background="var(--base-primary-bgColor)"  />
    </div>
    <div class="tips-box">
      <span>发布中，请稍后</span>
      <span>
        <span>点击</span>
        <span class="back-btn" @click="back">返回</span>
        <span>，发布过程不受影响</span>
      </span>
    </div>
  </div>
</template>

<script>
import Spin from "@/components/Spin.vue";
export default {
  data() {
    return {};
  },
  components: {
    Spin,
  },
  methods: {
    back() {
      let { projId, projName } = this.$route.params;
      let dataType = this.$route.query.dataType;
      projName = encodeURIComponent(projName);
      let path = `/singleProject/sceneList/${projId}/${projName}?dataType=${dataType}`;
      this.$router.push(path);
    },
  },
};
</script>

<style lang="less" scoped>
.publish-loadig-container {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100vh;
  z-index: 3;
  background: rgba(0, 0, 0, 0.5);

  .tips-box {
    position: absolute;
    top: calc(50% + 50px);
    left: calc(50% - 100px);
    display: flex;
    flex-direction: column;
    line-height: 25px;
    color: var(--aside-bg-color);

    .back-btn {
      color: var(--base-primary-bgColor);
      cursor: pointer;
    }
  }
}
</style>